/* global ADV */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Capsule, { CAROUSEL } from '../CommonComponents/MobileCapsule';
import ComponentDictionary from './GoalCarouselComponentDictionary';

class GoalCarouselView extends Component {
  componentDidMount() {
    const { clientId, fpId, fetchDataAndAllCharts } = this.props;

    fetchDataAndAllCharts(clientId, fpId);
  }

  renderChart(currentGoalData) {
    const { clientId, fpId, isInitialized, proposedPlan, isCurrentPlan } = this.props;

    if (!isInitialized) {
      return null;
    }
    const canAccessFinancialPlan =
      ADV.util.env('isAdviserArea') ||
      get(ADV, 'data.user.ModulesToHide', []).indexOf('FinancialPlan') < 0;
    const Chart = ComponentDictionary[currentGoalData.component].chart;
    return (
      <div className="tile full-width">
        <Capsule
          header={currentGoalData.name}
          subheader={null}
          className={CAROUSEL}
          href={canAccessFinancialPlan && 'NewFinancialPlanWhatIfs'}
          params={{
            clientId,
            goalId: currentGoalData.id,
          }}
          fpId={fpId}
          clientId={clientId}
        >
          <div
            key={currentGoalData.id}
            onClick={() => {
              if (!canAccessFinancialPlan) {
                return;
              }
              ADV.util.Router.go2('NewFinancialPlanWhatIfs', {
                clientId,
                goalId: currentGoalData.id,
              });
            }}
          >
            <Chart
              isCurrentPlan={isCurrentPlan}
              key={currentGoalData.id}
              fpId={fpId}
              proposedPlan={proposedPlan}
              goalId={currentGoalData.id}
              responseData={currentGoalData.chart}
              clientId={clientId}
            />
          </div>
        </Capsule>
      </div>
    );
  }

  render() {
    const { isInitialized, goalsList } = this.props;

    if (!isInitialized) {
      return null;
    }
    return <div>{goalsList.map(goal => this.renderChart(goal))}</div>;
  }
}

GoalCarouselView.propTypes = {
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  isInitialized: PropTypes.bool.isRequired,
  currentGoalData: PropTypes.shape({}).isRequired,
  proposedPlan: PropTypes.string.isRequired,
  fetchDataAndAllCharts: PropTypes.func.isRequired,
  goalsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  initialChartData: PropTypes.shape({}).isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
};

export default GoalCarouselView;
